//src\views\apps\mis-ventas\masnet\store\reducer\index.js
const initialState = {
  data: [],
  total: 0,
  eventosTarea: [],
  params: {
    q: '',
    page: 1,
    perPage: 10,
    sortBy: 'p.id', // debe existir en whitelist del backend
    sortOrder: 'ASC',
  },
};

const masnetVentas = (state = initialState, action) => {
  switch (action.type) {
    case 'MASNET_VENTAS/SET': {
      const {data, total, params} = action.payload || {};
      return {
        ...state,
        data: Array.isArray(data) ? data : [],
        total: typeof total === 'number' ? total : 0,
        params: {...state.params, ...(params || {})},
      };
    }

    case 'SET_EVENTOS_TAREA':
      return {
        ...state,
        eventosTarea: Array.isArray(action.data) ? action.data : [],
      };

    default:
      return state;
  }
};

export default masnetVentas;
